module.exports = __webpack_public_path__ + "img/IMGP8630b.14193ca5.jpg";